import ActionTypes from '../actions/types';
import { setState, appendItemToStateArray, deleteItemToStateArray } from './helper';
import { defaultState } from './defaultState';
/*eslint no-case-declarations: 0 */

/**
  This is storage reducers.
  we are saving this reducers data to localStorage.
**/

const initialState = defaultState.storage;

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_MAP_GEO_JSON:
      return setState(state, action, 'mapGeoJson');
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/storageReducer.js